import { SellerTypeListEnum } from "../enums/SellerTypeListEnum"

export class SellerModel {
    id: string = ""
    name: string = ""
    realName: string = ""
    email: string|null = ""
    cnpj: string|null = ""
    idExternal: string = ""
    type: SellerTypeListEnum = SellerTypeListEnum.Alterdata
    percFirstYear: number = 0
    percSecondYear: number = 0
    percSetup: number = 0
    parent?: SellerModel
    loadingListAction?: boolean = false

    constructor(s?:Partial<SellerModel>) {
        Object.assign(this, s)

        this._parseParent()
    }

    private _parseParent():void {
        if (!!this.parent) {
            this.parent = new SellerModel(this.parent)
        }
    }
}

